@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.labeled-info-list {
  margin: 0;
  dd {
    margin: 0;
    padding-bottom: 8px;
  }
}

.label {
  font-size: 12px;
  line-height: 18px;
  color: @labeled-info--text-color;
}

.info {
  font-size: 14px;
  line-height: 18px;
}

.mdash {
  color: @labeled-info--text-color;
}

.spinner {
  transform: scale(0.5);
}
